import Hobby1SVG from "../../../../svgs/pricing/Hobby1SVG";
import Pin from "../../../systemDesign/Sep/Pin";
import Cubes from "./Cubes";
import Hobby2SVG from "../../../../svgs/pricing/Hobby2SVG";
import Hobby3SVG from "../../../../svgs/pricing/Hobby3SVG";
import Hobby4SVG from "../../../../svgs/pricing/Hobby4SVG";
import Hobby7SVG from "../../../../svgs/pricing/Hobby7SVG";
import Hobby6SVG from "../../../../svgs/pricing/Hobby6SVG";
import Hobby5SVG from "../../../../svgs/pricing/Hobby5SVG";
import PlansText from "./PlansText";
import Pro1SVG from "../../../../svgs/pricing/Pro1SVG";
import Pro2SVG from "../../../../svgs/pricing/Pro2SVG";
import Pro3SVG from "../../../../svgs/pricing/Pro3SVG";
import Pro4SVG from "../../../../svgs/pricing/Pro4SVG";
import Pro5SVG from "../../../../svgs/pricing/Pro5SVG";
import Pro6SVG from "../../../../svgs/pricing/Pro6SVG";
import Enterprise1SVG from "../../../../svgs/pricing/Enterprise1SVG";
import Enterprise6SVG from "../../../../svgs/pricing/Enterprise6SVG";
import Enterprise5SVG from "../../../../svgs/pricing/Enterprise5SVG";
import Enterprise4SVG from "../../../../svgs/pricing/Enterprise4SVG";
import Enterprise3SVG from "../../../../svgs/pricing/Enterprise3SVG";
import Enterprise2SVG from "../../../../svgs/pricing/Enterprise2SVG";
import ArrowRight2SVG from "../../../../svgs/ArrowRight2SVG";

const Plans = () => {
  return (
    <div className="w-full">
      <div className="w-full flex flex-col">
        <Pin className="left-[-10px] -top-[10.5px]" />
        <Cubes className="border-b" />
        <div className="w-[83.3%] mx-auto py-16 border-x border-subColor4 flex flex-col justify-center items-center gap-5">
          <h1 className="text-subColor5 text-[24px] lg:text-[34px] xl:text-[40px] txl:text-[48px] font-bold">
            Find a plan to power your projects.
          </h1>
          <h3 className="text-subColor3 text-[10px] lg:text-[14px] xl:text-[17px] txl:text-[20px]">
            From early-stage startups to growing enterprises, Vercel has you
            covered.
          </h3>
        </div>
        <Cubes className="border-t" />
      </div>
      <div className="flex items-center relative border-y border-subColor4 [&>div]:w-1/3 [&>div]:h-full [&>div]:py-10 [&>div]:px-9 [&>div]:border-r [&>div]:border-subColor4 [&>div:last-child]:border-none">
        <Pin className="right-[-10px] -top-[10.5px]" />
        <div>
          <h2 className="text-subColor5 text-[24px] mb-3 font-semibold">
            Hobby
          </h2>
          <h3 className="text-subColor3 txl:pr-16 xl:text-[18px]">
            Everything you need to kickstart your web project.
          </h3>
          <div className="flex flex-col gap-4 mt-8">
            <PlansText
              svg={<Hobby1SVG />}
              text="Import your repo, deploy in seconds"
            />
            <PlansText svg={<Hobby2SVG />} text="Automatic CI/CD" />
            <PlansText svg={<Hobby3SVG />} text="Serverless Compute" />
            <PlansText
              svg={<Hobby4SVG />}
              text="Traffic & performance insights"
            />
            <PlansText svg={<Hobby5SVG />} text="DDoS Mitigation" />
            <PlansText svg={<Hobby6SVG />} text="Web Application Firewall" />
            <PlansText svg={<Hobby7SVG />} text="Community Support" />
          </div>
          <div className="w-full py-3 mt-10 flex justify-between items-center px-4 rounded-full bg-[#0A0A0A] text-subColor5 border border-subColor4">
            <span>Start Deploying</span>
            <ArrowRight2SVG width={24} />
          </div>
        </div>
        <div className="bg-[#0a0a0a]">
          <h2 className="text-subColor5 text-[24px] mb-3 font-semibold">Pro</h2>
          <h3 className="text-subColor3 txl:pr-16 xl:text-[18px]">
            Collaborate with a team for{" "}
            <span className="text-subColor5">$20 /month</span>, per member.
          </h3>
          <div className="flex flex-col gap-4 mt-8">
            <PlansText text="Everything in Hobby, plus:" />
            <PlansText svg={<Pro1SVG />} text="Secure team collaboration" />
            <PlansText svg={<Pro2SVG />} text="Frontend Observability tools" />
            <PlansText svg={<Pro3SVG />} text="Advanced Protection" />
            <PlansText svg={<Pro4SVG />} text="Scales with you" />
            <PlansText svg={<Pro5SVG />} text="Spend management" />
            <PlansText svg={<Pro6SVG />} text="Email support" />
          </div>
          <div className="w-full py-3 mt-10 flex justify-between items-center px-4 rounded-full bg-[#0072F5] text-subColor5">
            <span>Start a free trial</span>
            <ArrowRight2SVG width={24} />
          </div>
        </div>
        <div>
          <h2 className="text-subColor5 text-[24px] mb-3 font-semibold">
            Enterprise
          </h2>
          <h3 className="text-subColor3 txl:pr-16 xl:text-[18px]">
            Critical security, performance, observability and support.
          </h3>
          <div className="flex flex-col gap-4 mt-8">
            <PlansText text="Everything in Pro, plus:" />
            <PlansText
              svg={<Enterprise1SVG />}
              text="Guest & Team access controls"
            />
            <PlansText svg={<Enterprise2SVG />} text="SCIM & Directory Sync" />
            <PlansText svg={<Enterprise3SVG />} text="Managed WAF Rulesets" />
            <PlansText
              svg={<Enterprise4SVG />}
              text="Multi-region compute & failover"
            />
            <PlansText svg={<Enterprise5SVG />} text="99.99% SLA" />
            <PlansText svg={<Enterprise6SVG />} text="Advanced Support" />
          </div>
          <div className="w-full flex items-center justify-between gap-3 mt-10">
            <div className="w-[57%] py-3 flex justify-between items-center px-4 rounded-full bg-white text-[#0a0a0a]">
              <span>Contact Sales</span>
              <ArrowRight2SVG width={24} className="[&>path]:fill-black" />
            </div>
            <div className="w-[43%] py-3 flex justify-between items-center px-4 rounded-full bg-[#0A0A0A] text-subColor5 border border-subColor4">
              <span>Request Trial</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Plans;
